module.exports = __webpack_public_path__ + "img/cirno.89ecff2e.png";